export const unstable_settings = {
  initialRouteName: 'index',
};

export { default } from 'navigation/layouts/offers-layout';
